import React, { useEffect, useState } from "react";
import { notify } from "react-notify-toast";
import Select from "react-select";
import db from "../firebase";

export default function BrowserNotification() {
  const [user, setuser] = useState(JSON.parse(localStorage.getItem("Ubytes")));
  const [branches, setbranch] = useState();
  const [title, settitle] = useState("");
  const [message, setmessage] = useState("");
  const [selectedBranch, setselectedBranch] = useState([]);
  useEffect(async () => {
    if (user.role === "Branch") {
      let doc = await db.collection("Branches").doc(user.branchId).get();
      doc.data()["value"] = doc.data().branchName;
      doc.data()["label"] = doc.data().branchName;
      setbranch(doc.data());
    } else if (user.role === "Merchant") {
      let doc = await db
        .collection("Branches")
        .where("of", "==", user.uid)
        .get();

      let branch = [];
      doc.forEach((d) => {
        let _ = d.data();
        _["value"] = d.data().branchName;
        _["label"] = d.data().branchName;
        branch.push(_);
      });

      setbranch(branch);
    }
  }, [user]);
  const sendNotifications = async () => {
    selectedBranch.forEach(async (branch) => {
      await db
        .collection("notifications")
        .add({
          for: branch.branchId,
          title: title,
          message: message,
          at: new Date(),
          from: user.brandName,
        })
        .then((doc) => doc.update({ id: doc.id, seen: false }));
    });
    notify.show("Notifications send Successfully!", "success");
  };
  return (
    <div className="brow-body">
      <p>Send Browser Notification</p>
      <small>Send Browser Notification to your branches or sub branches.</small>
      <div className="brow-row">
        <p>Select branch:</p>
        <Select
          isMulti
          onChange={(e) => setselectedBranch(e)}
          options={branches}
          value={selectedBranch}
        ></Select>
      </div>
      <div className="brow-form">
        <p>Enter Title of Notification:</p>
        <input
          onChange={(e) => settitle(e.target.value)}
          style={{ marginBottom: "20px" }}
        ></input>
        <p>Enter Message:</p>
        <textarea
          onChange={(e) => setmessage(e.target.value)}
          style={{ height: "10rem" }}
        ></textarea>
      </div>
      <div
        className="brow-row"
        style={{ alignItems: "flex-start", justifyContent: "flex-end" }}
      >
        <button onClick={sendNotifications}>Send</button>
      </div>
    </div>
  );
}
